import { Widget, WidgetContent, WidgetHeaderWithQuery } from '@fortem-monorepo/react-spa'

import { CtaExposureBoxPlotChart } from '@/pages/funds/ic-report/components/primitives/charts/CtaExposureBoxPlotChart'
import { CtaExposureAggregatedTable } from '@/pages/funds/ic-report/components/primitives/tables/CtaExposureAggregatedTable'
import { useICStreamContext } from '@/pages/funds/ic-report/ic-report-context.context'
import { diversifiers } from '@/react-query/queries/ic-report/hooks'

export interface CtaExposureProps {}

export const CtaExposure: React.FC<CtaExposureProps> = () => {
  const { params } = useICStreamContext()
  const query = diversifiers.useCtaExposure(params)
  const data = query.data

  return (
    <div className={'flex gap-4'}>
      <Widget>
        <WidgetHeaderWithQuery title="CTA Exposure Aggregated" query={query} />
        <WidgetContent className={'h-full'}>
          <CtaExposureAggregatedTable data={data?.aggregated} loading={query.isLoading} />
        </WidgetContent>
      </Widget>
      <Widget>
        <WidgetHeaderWithQuery title="CTA Exposure Box Plot" query={query} />
        <WidgetContent className={'min-h-full'}>
          <CtaExposureBoxPlotChart weights={data?.weights ?? []} />
        </WidgetContent>
      </Widget>
    </div>
  )
}
